"use strict";

// ---------------------------------------------------------------
// Collection page - Multi-Year Legacy Fix
// ---------------------------------------------------------------

/*! Helper Functions -------------------------------------------------- */

// Fallback for missing theme functions to prevent fatal crashes
if (typeof append_url !== 'function') { window.append_url = function(a, b, c) { console.warn('append_url missing'); }; }
if (typeof new_css !== 'function') { window.new_css = function(a, b) { console.warn('new_css missing'); }; }
if (typeof toggle_dropdowns_simple !== 'function') { window.toggle_dropdowns_simple = function(a) { a.classList.toggle('toggle'); }; }
var validation_css = window.validation_css || "";

// Saves a collection view preference to the cart attributes via a POST request
function saveCollectionview(attribute, value) {
	if (typeof routes === 'undefined' || !routes.cart_update_url) {
		console.warn('saveCollectionview skipped: routes.cart_update_url is not defined');
		return;
	}

	const config = {
		method: 'POST',
		body: JSON.stringify({
			attributes: {
				[attribute]: value
			}
		}),
		headers: {
			'X-Requested-With': 'XMLHttpRequest',
			'Content-Type': 'application/json',
			'Accept': 'application/javascript'
		}
	};
	fetch(routes.cart_update_url, config)
		.then(res => res.json())
		.then(res => {
			if (res.status && typeof handleErrorMessage === 'function') handleErrorMessage(res.description);
		})
		.catch(error => {
			console.warn('saveCollectionview error', error);
		});
}

function insertAfter(referenceNode, newNode) {
	referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

function clearRangeInputs() {
	const minInput = document.querySelector('#filter input#min');
	const maxInput = document.querySelector('#filter input#max');
	if (minInput) minInput.removeAttribute('name');
	if (maxInput) maxInput.removeAttribute('name');
}

function clearAllInputs() {
	clearRangeInputs();
	document.querySelectorAll('#filter input[type="checkbox"]:checked').forEach(el => el.checked = false);
}

function saveLoadMoreAnchor() {
	const anchors = document.querySelectorAll('#collection > li > figure > a, .m6cl .results > div a, .m6cl .results > .l4ne a');
	for (const el of anchors) {
		el.addEventListener('click', () => {
			localStorage.setItem('loadMoreItemClicked', el.getAttribute('href'));
		});
	}
}

/*! Custom Events - FIXED with Soft Assignments --------------------- */

window.navAsideEvt = window.navAsideEvt || new CustomEvent('navAside');
window.addEventListener('navAside', () => {
	const nav_aside = document.querySelectorAll('.n6as a.toggle:not(.n6as-initialized)');
	if (!nav_aside.length) return;
	for (const el of nav_aside) {
		el.classList.add('n6as-initialized');
		el.addEventListener('click', e => {
			e.preventDefault();
			toggle_dropdowns_simple(el.parentElement);
		});
	}
});
window.dispatchEvent(window.navAsideEvt);

let forceFormFilterRender = false;
window.filtersEvt = window.filtersEvt || new CustomEvent('filters');
window.addEventListener('filters', function (evt) {
	const form_filter = document.getElementsByClassName('f8fl');
	const html_tag = document.documentElement;

	if (form_filter.length) {
		html_tag.classList.add('t1cl');
		let formFilterRendered = false;

		function renderFormFilter() {
			if (formFilterRendered) return;
			for (const el of form_filter) {
				append_url(el, 'Close', 'f8fl-toggle');
				const elementId = el.id;
				if (elementId) {
					const links = document.querySelectorAll(`[href="#${elementId}"]`);
					for (const link of links) { link.classList.add('f8fl-toggle'); }
				}
				const headers = el.querySelectorAll('h1, h2, h3, h4, h5, h6');
				for (const header of headers) { append_url(header, 'Close', 'header-toggle'); }
			}
			const toggles = document.getElementsByClassName('f8fl-toggle');
			for (const el of toggles) { el.setAttribute('aria-controls', 'filter'); }
			formFilterRendered = true;
		}

		function handleFilterClick(event) {
			renderFormFilter();
			if (event.target.closest('a[aria-controls="filter"]')) {
				html_tag.classList.add('has-filters');
				html_tag.classList.toggle('f8fl-open');
				if (event.target.closest('.m6pn') && typeof overlayClose === 'function') overlayClose();
				event.preventDefault();
			}
		}

		function handleFilterSub(event) {
			const link = event.target.closest('.f8fl a.header-toggle');
			if (!link) return;
			const closestH = link.closest('h1, h2, h3, h4, h5, h6');
			toggle_dropdowns_simple(closestH);
			event.preventDefault();
		}

		if (forceFormFilterRender) { renderFormFilter(); forceFormFilterRender = false; }
		if (!formFilterRendered) {
			document.addEventListener('click', handleFilterClick);
			document.addEventListener('click', handleFilterSub);
		}
	}
});
window.dispatchEvent(window.filtersEvt);

// #filter - Logic --------------------------------------------------
window.initFiltersEvt = window.initFiltersEvt || new CustomEvent('initFilters');
window.addEventListener('initFilters', function (evt) {
	const filter_form = document.getElementById('filter');
	if (!filter_form) return;

	new_css('form-validation-css', window.validation_css || "");

	var processFilters = function () {
		var filter_form_template = filter_form.dataset.template;
		var collectionSection = document.getElementById('shopify-section-' + filter_form_template);
		filter_form.classList.add('processing');

		var filterFormData = new FormData(filter_form);
		var filterParams = new URLSearchParams(filterFormData).toString();
		const filterUrl = window.location.pathname + '?section_id=' + filter_form_template + '&' + filterParams;

		fetch(filterUrl)
			.then((response) => response.text())
			.then((text) => {
				const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-' + filter_form_template);
				collectionSection.innerHTML = resultsMarkup.innerHTML;

				// Re-trigger events to wake up the page
				window.dispatchEvent(new CustomEvent('nav'));
				window.dispatchEvent(window.initFiltersEvt);
				window.dispatchEvent(window.filtersEvt);
			})
			.catch(err => console.warn(err));
	};

	filter_form.querySelectorAll('input').forEach(el => el.addEventListener('change', processFilters));
});
window.dispatchEvent(window.initFiltersEvt);

// #load-more-button -----------------------------------------------
window.collectionLoadMoreEvt = window.collectionLoadMoreEvt || new CustomEvent('collectionLoadMore');
window.addEventListener('collectionLoadMore', function (evt) {
	const collection_load_more = document.querySelectorAll('#load-more-button[data-next], #load-more-button[data-prev]');
	if (!collection_load_more.length) return;

	Array.from(collection_load_more).forEach(function (button) {
		button.addEventListener('click', function (e) {
			e.preventDefault();
			button.classList.add('loading');
			fetch(button.getAttribute('href'))
				.then((res) => res.text())
				.then((text) => {
					// Pagination logic...
					button.classList.remove('loading');
					window.dispatchEvent(window.collectionLoadMoreEvt);
				});
		});
	});
});
window.dispatchEvent(window.collectionLoadMoreEvt);

// #sort_by - FIXED with soft assignment -------------------------
window.collectionSortEvt = window.collectionSortEvt || new CustomEvent('collectionSort');
window.addEventListener('collectionSort', function (evt) {
	const sort_by = document.getElementById('sort_by');
	if (!sort_by || sort_by.getAttribute('data-collection-sort-bound') === '1') return;
	sort_by.setAttribute('data-collection-sort-bound', '1');

	sort_by.addEventListener('change', function () {
		const url = new URL(window.location.href);
		url.searchParams.set('sort_by', this.value);
		window.location.href = url.href;
	});
});
window.dispatchEvent(window.collectionSortEvt);

// FINAL OVERRIDE: Ensure Dropdowns work on Collection Pages
window.addEventListener('load', function() {
	console.log("Xtra Theme: Finalizing dropdown listeners...");
	window.dispatchEvent(new CustomEvent("nav")); // Wake up the main nav script

	// Backup hover logic in case the main script is still blocked
	const nav = document.getElementById('nav') || document.getElementById('nav-bar');
	if (nav) {
		nav.querySelectorAll('li').forEach(li => {
			li.addEventListener('mouseenter', () => document.documentElement.classList.add('nav-hover'));
			li.addEventListener('mouseleave', () => document.documentElement.classList.remove('nav-hover'));
		});
	}
});